import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { config } from './environments/environment';

if (config.production) {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.debug = () => {};
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
